import type { ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  sub?: string;
  children: ReactNode;
}

/** Themed section wrapper used by every dashboard panel. */
export function SectionCard({ title, sub, children }: SectionCardProps) {
  return (
    <section className="dash-section">
      <h2>{title}</h2>
      {sub && <p className="dash-section__sub">{sub}</p>}
      {children}
    </section>
  );
}
